import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="glasgow"
export default class extends Controller {
  static targets = ["verbal", "motor", "ocular", "total"];

  connect() {
    this.calculate();
  }

  calculate() {
    const verbal = parseInt(this.verbalTarget.value) || 0;
    const motor = parseInt(this.motorTarget.value) || 0;
    const ocular = parseInt(this.ocularTarget.value) || 0;

    const total = verbal + motor + ocular;

    this.totalTarget.value = total;
  }
}
